import { Link } from "react-router-dom";
import ProgressBar from "../components/ProgressBar";
import { useState, useEffect } from "react";

export default function Step0() {
  const [selectedType, setSelectedType] = useState("pas_client");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    // Les champs commencent toujours vides - pas de récupération des données sauvegardées
    setSelectedType("pas_client");
  }, []);

  // const handleNewForm = () => {
  //   // Vider tout le localStorage pour commencer un nouveau formulaire
  //   localStorage.clear();
  //   setSelectedType('particulier');
  //   setErrors({});
  // };

  const handleContinue = (e) => {
    if (selectedType !== "pas_client") {
      setErrors({
        type: 'Seul le type "Pas client" est disponible pour le moment.',
      });
      e.preventDefault();
      return;
    }
    setErrors({});
    localStorage.setItem("selectedType", selectedType);
  };

  return (
    <div className="subscribe py-10 lg:py-16 bg-[#e4eef9]">
      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
        <h1 className="text-center text-4xl font-bold">
          Formulaire de souscription
        </h1>
        <div className="mt-10">
          <ProgressBar currentStep={1} />
          <div className="mt-8 bg-white p-6 lg:p-10 rounded-xl shadow-sm">
            <div className="mb-6">
              <label className="text-xl font-bold text-secondary">1. Êtes-vous  un de nos clients ? :</label>
              <div className="flex gap-4 mt-4">
                <label
                  className={`inline-flex items-center gap-2 px-6 py-3 rounded-full cursor-pointer transition ${selectedType === "pas_client" ? "bg-secondary text-white" : "border border-gray-800 hover:bg-gray-100"}`}
                >
                  <input
                    type="radio"
                    name="type"
                    className="sr-only"
                    checked={selectedType === "pas_client"}
                    onChange={() => {
                      setSelectedType("pas_client");
                      setErrors({});
                    }}
                  />
                  Non
                </label>
                <label
                  className={`inline-flex items-center gap-2 px-6 py-3 rounded-full cursor-not-allowed opacity-50 ${selectedType === "client" ? "bg-secondary text-white" : "border border-gray-800"}`}
                >
                  <input
                    type="radio"
                    name="type"
                    className="sr-only"
                    disabled
                    checked={selectedType === "client"}
                    onChange={() => {
                      setSelectedType("client");
                      setErrors({});
                    }}
                  />
                  Oui
                </label>
              </div>
              {errors.type && (
                <p className="text-red-500 text-sm mt-1">{errors.type}</p>
              )}
            </div>

            <div className="flex justify-center mx-auto mt-8 pt-6 border-t">
              <Link
                to="/step-1"
                onClick={handleContinue}
                className="rounded-full bg-primary px-4 py-3 text-secondary font-medium flex items-center gap-2 mx-auto text-center"
              >
                Continuer <span>→</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
